<template>
  <transition name="loader">
    <div class="loader" v-if="loading"></div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'loader',
  computed: {
    ...mapGetters({
      loading: 'loading/loading'
    })
  },
  methods: {
    ...mapActions({
      loader: 'loading/loader'
    })
  }
}
</script>